import { render, staticRenderFns } from "./DefaultHeaderProfileDropdown.vue?vue&type=template&id=b1fdaf40&"
import script from "./DefaultHeaderProfileDropdown.vue?vue&type=script&lang=js&"
export * from "./DefaultHeaderProfileDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DefaultHeaderProfileDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports